<div class="minute-container">
  <div [ngStyle]="isFirst ? {'opacity': '0'} : {}" class="line"></div>
  <span [ngClass]="{
  'goal': isGoal,
  'red-card': isRedCard
}" class="minute">{{ item.display_minute }}</span>
  <div [ngStyle]="isLast ? {'opacity': '0'} : {}" class="line"></div>
</div>
<div class="content-container {{colorScheme.main}}">
  <!-- Header -->
  <div *ngIf="!isComment" class="item-header">
    <img class="symbol-image" [src]="item.symbol" alt="Category">
    <h4>{{ item.title }}</h4>
    <img *ngIf="teamPictures?.length" class="team-image" [src]="teamPictures | imageUrlBySubtype : imageType : imageRes">
  </div>
  <!-- Media -->
  <lib-image-carousel *ngIf="hasVideo || mainImages?.length"
                      class="image-carousel"
                      [ngClass]="isComment ? 'remove-top-margin' : ''"
                      [paywall]="true"
                      [user]="matchService.user"
                      [videos]="videos"
                      [trackingInfo]="trackingInfo"
                      [autoStartVideo]="false"
                      imageMaxHeight="200px"
                      [images]="mainImages">
  </lib-image-carousel>
  <!-- Content -->
  <div class="item-content">
    <img *ngIf="!isGoal && playerImage" class="player-image" [src]="playerImage" alt="Player">
    <p [innerHTML]="item.text"></p>
  </div>
  <!-- Goal player container -->
  <div *ngIf="isGoal" class="player-goal">
    <img *ngIf="playerImage" class="player-image" [src]="playerImage" alt="Player">
    <img *ngIf="teamPictures" class="team-image" [src]="teamPictures | imageUrlBySubtype : imageType : imageRes"
         alt="Team">
    <span>{{ lineupPlayerName }}</span>
    <mat-icon>sports_soccer</mat-icon>
  </div>
  <div *ngIf="isSubstitution && players" class="item-substitution">
    <div *ngIf="players.inPlayer" class="player-substitution">
      <img *ngIf="players.inPlayer.imgUrl" class="player-image" [src]="players.inPlayer.imgUrl" alt="Player">
      <span>{{ players.inPlayer.playername }}</span>
      <mat-icon>arrow_circle_left</mat-icon>
    </div>
    <div *ngIf="players.outPlayer" class="player-substitution">
      <img *ngIf="players.outPlayer.imgUrl" class="player-image" [src]="players.outPlayer.imgUrl" alt="Player">
      <span>{{ players.outPlayer.playername }}</span>
      <mat-icon>arrow_circle_right</mat-icon>
    </div>
  </div>
</div>

